const input_name_in_quickbooks = document.querySelector(
    ".js-input-name-in-quickbooks"
);
const input_name_of_agency = document.querySelector(".js-input-agency-name");

if (input_name_in_quickbooks && input_name_of_agency) {
    const form = input_name_in_quickbooks.closest("form");

    if (form) {
        form.addEventListener("submit", () => {
            if (!input_name_in_quickbooks.value) {
                const name_agency = input_name_of_agency.value;

                input_name_in_quickbooks.value = name_agency;
            }
        });
    }
}
